var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpoerBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15131",
    "data-name": "Group 15131",
    transform: "translate(-1657 -700)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8008",
    "data-name": "Rectangle 8008",
    width: 42,
    height: 42,
    rx: 5,
    ry: 5,
    transform: "translate(1657 700)",
    fill: "rgba(243, 237, 237, 0.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_524",
    "data-name": "Union 524",
    d: "M8.889,14.445A5.555,5.555,0,1,1,14.445,20,5.562,5.562,0,0,1,8.889,14.445Zm4.889-1.056v3.721a.666.666,0,1,0,1.333,0V13.387l.862.862a.667.667,0,1,0,.943-.943l-2-2a.668.668,0,0,0-.942,0l-2,2a.667.667,0,1,0,.943.943l.86-.859,0,0ZM10.755,20H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H8.586A2.012,2.012,0,0,1,10,.586L15.414,6A2.015,2.015,0,0,1,16,7.414v.546a6.714,6.714,0,0,0-1.556-.183c-.148,0-.3.005-.444.014V7.414L8.586,2H3A1,1,0,0,0,2,3V17a1,1,0,0,0,1,1H8.8a6.755,6.755,0,0,0,1.95,2l0,0ZM7.8,15H5a1,1,0,1,1,0-2H7.935a6.67,6.67,0,0,0-.158,1.444c0,.184.008.372.023.554v0Zm.936-4H5A1,1,0,1,1,5,9h5.6a6.657,6.657,0,0,0-1.86,2Z",
    transform: "translate(1660 703)",
    opacity: 0.8,
    fill: "#242424"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoerBg);
export default __webpack_public_path__ + "static/media/expoer-bg.bfd214bae5c0c52985848364bcaea859.svg";
export { ForwardRef as ReactComponent };